import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Container, Eyebrow } from "@/components/site/Primitives";
import { Wordmark } from "@/components/site/Nav";

const SECTIONS = [
  ["What we collect", [
    "Assessment requests: your description of the business need and any selected areas, your name, email, organization, organization type (optional), country, any follow-up answers you add, and — only if you request a callback — your phone number, preferred time and time zone.",
    "Applications to join our AI team: your name, email, country of residence, chosen track, expertise areas, experience range, and an optional profile link and note.",
    "We also record the time of your submission and your consent to be contacted.",
  ]],
  ["Why we use it", [
    "Assessment details are used to review your business need and contact you about that assessment. Application details are used to review your application and contact you about it. We don’t sell your details.",
  ]],
  ["Consent and contact", [
    "Each form asks for your agreement before we contact you. We contact you only about the assessment or application you submitted.",
  ]],
  ["Who can access it", [
    "Submissions are reviewed by the FreelancAI owner through a password-protected review area. Our hosting, database and site-building service providers process this data as part of running the website.",
  ]],
  ["Site scripts", [
    "This site loads scripts from our site-building and hosting platform, which include product analytics that may record how pages are used. We don’t add our own advertising trackers.",
  ]],
  ["Please don’t send sensitive information", [
    "We don’t ask for medical, legal-privileged or other confidential information. Please don’t include it in your descriptions or notes.",
  ]],
  ["How long we keep it", [
    "We keep submitted details while they’re needed for the assessment or recruitment process, and review them for deletion when they’re no longer needed.",
  ]],
  ["Access and deletion", [
    "To ask what we hold about you, or to request correction or deletion, email admin@freelancai.com.",
  ]],
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="theme-dark min-h-screen bg-canvas text-fg">
      <header className="border-b border-fg/[0.06]">
        <Container className="flex h-16 items-center justify-between">
          <Link to="/" aria-label="FreelancAI home" className="rounded-sm"><Wordmark /></Link>
          <Link to="/" data-testid="privacy-home-link" className="fa-link inline-flex items-center gap-2 rounded-sm text-[13px] text-subtle hover:text-fg"><ArrowLeft size={14} aria-hidden /> Home</Link>
        </Container>
      </header>
      <Container className="pb-24 pt-14">
        <article className="max-w-2xl">
          <Eyebrow className="text-tone">Privacy</Eyebrow>
          <h1 className="mt-5 font-display text-4xl font-light tracking-[-0.04em] sm:text-5xl">Privacy notice</h1>
          <p className="mt-5 text-[15px] leading-relaxed text-subtle">How FreelancAI handles the details you submit through this website.</p>
          {SECTIONS.map(([title, paras]) => (
            <section key={title} className="mt-10">
              <h2 className="font-display text-base font-normal tracking-[-0.01em] md:text-lg">{title}</h2>
              {paras.map((p) => <p key={p.slice(0, 24)} className="mt-3 text-[14px] leading-relaxed text-subtle">{p}</p>)}
            </section>
          ))}
          <p className="mt-12 text-[13px] text-subtle">
            Questions: <a href="mailto:admin@freelancai.com" data-testid="privacy-contact-email" className="fa-link rounded-sm text-fg underline underline-offset-4">admin@freelancai.com</a>
          </p>
        </article>
      </Container>
    </div>
  );
}
